// 组件对象，大写
import modalGoodsSelect from './modalGoodsSelect.vue'
export default modalGoodsSelect
